// import axios from "axios";
import { getAnalytics, logEvent } from "firebase/analytics";

class LoggingService {
  store;
  router;

  constructor() {
    /* Caso precise enviar enviar para o backend      */
    //this.endpoint = `${process.env.VUE_APP_API_BASE_URL}/teste-log`;
  }

  setStore(store) {
    this.store = store;
  }

  setRouter(router) {
    this.router = router;
  }

  sendLogs(logs) {
    try {
      // Caso precise enviar enviar para o backend
      // await axios.post(this.endpoint, logs);

      const analytics = getAnalytics();

      logEvent(analytics, "logger_service", logs);
    } catch (error) {
      console.error("Failed to send logs:", error);
    }
  }

  formatLog(type, data) {
    return {
      type,
      timestamp: new Date().toISOString(),
      user_email: this.getCurrentUserEmail(),
      route: this.getCurrentRoute(),
      user_agent: navigator.userAgent,
      session_id: this.getSessionId(),
      ...data,
    };
  }

  getCurrentUserEmail() {
    return this.store?.getters?.currentUser?.email || null;
  }

  getCurrentRoute() {
    return this.router?.currentRoute?.path || window.location.pathname;
  }

  getSessionId() {
    let sessionId = sessionStorage.getItem("session_id");
    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem("session_id", sessionId);
    }
    return sessionId;
  }

  logError(type, error, extraData = {}) {
    const errorLog = this.formatLog(type, {
      event_category: "Error",
      event_label: error.message || String(error),
      value: 1,
      stack: error.stack,
      ...extraData,
    });

    this.sendLogs(errorLog);
  }

  logEvent(name, data = {}) {
    const eventLog = this.formatLog("event", {
      event_category: "Event",
      event_label: name,
      value: 1,
      ...data,
    });

    this.sendLogs(eventLog);
  }
}

const loggingService = new LoggingService();

export default loggingService;
